import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'fix.env',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'fix.env',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'fix.env',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'fix.env',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || 'fix.env',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || 'fix.env',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || 'fix.env',
};

const firebaseApp = initializeApp(firebaseConfig);
const isSupportedBrowser = await isSupported()
export const firebaseMessaging = isSupportedBrowser ? getMessaging(firebaseApp) : {}

// True only when the browser can actually run Firebase Web Messaging
// (real Service Worker + Notification support). In native WebViews (iOS
// WKWebView) this is false, so callers can safely skip the web push path.
export const isWebMessagingSupported = isSupportedBrowser &&
  typeof navigator !== 'undefined' &&
  !!navigator.serviceWorker

export const getAccessToken = async () => {
  if (firebaseConfig.projectId === 'fix.env') return ''
  if (!isWebMessagingSupported) return ''

  try {
    const firebaseConfigParams = new URLSearchParams(firebaseConfig).toString()

    const serviceWorkerRegistration = await navigator.serviceWorker
      .register(
        `/firebase-messaging-sw.js?${firebaseConfigParams}`,
      )

    const token = await getToken(firebaseMessaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
      serviceWorkerRegistration,
    })

    return token || ''
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to obtain web push token', error)
    return ''
  }
}

export const getPermission = async () => {
  if (typeof Notification === 'undefined') return false
  const permission = await Notification.requestPermission()
  return permission === 'granted'
}
